<ul #nav="ngbNav" [activeId]="1" class="flex-column flex-sm-row nav nav-fill nav-pills mb-4" ngbNav orientation="horizontal">
  <li [ngbNavItem]="1">
    <a class="flex-sm-fill text-sm-center" ngbNavLink><b>1.</b> Identificação</a>
    <ng-template ngbNavContent>
      <div class="d-flex flex-row mb-2">
        <div class="form-group col">
          <label class="form-control-label">Designação</label>
          <p class="form-control-plaintext m-0 p-0">{{ record.institutionClient?.designation }}</p>
        </div>
        <div class="form-group col">
          <label class="form-control-label">Distrito</label>
          <p class="form-control-plaintext m-0 p-0">{{ 'app.District.' + record.institutionClient?.locationAuthority | translate }}</p>
        </div>
        <div class="form-group col">
          <label class="form-control-label">N.º Contribuinte</label>
          <p class="form-control-plaintext m-0 p-0">{{ record.institutionClient?.corporateTaxpayerNumber }}</p>
        </div>
        <div class="form-group col">
          <label class="form-control-label">Estado</label>
          <p class="form-control-plaintext m-0 p-0">
            <span class="badge badge-{{ record.institutionClient?.institutionStatus }}">{{
              'app.InstitutionStatus.' + record.institutionClient?.institutionStatus | translate
            }}</span>
          </p>
        </div>
      </div>
      <div class="d-flex flex-row mb-2">
        <div class="form-group col">
          <label class="form-control-label">N.º Segurança Social</label>
          <p class="form-control-plaintext m-0 p-0">{{ record.institutionClient?.socialSecurityNumber }}</p>
        </div>
        <div class="form-group col">
          <label class="form-control-label">ID Registo Único</label>
          <p class="form-control-plaintext m-0 p-0">{{ record.institutionClient?.id }}</p>
        </div>
        <div class="form-group col">
          <label class="form-control-label">Pública</label>
          <p class="form-control-plaintext m-0 p-0">
            <jhi-boolean [textFalse]="'Não'" [textTrue]="'Sim'" [value]="record.institutionClient?.isPublic || false"></jhi-boolean>
          </p>
        </div>
      </div>
      <div class="d-flex flex-row mb-2">
        <div class="form-group col col-lg-4">
          <label class="form-control-label" jhiTranslate="app.young.phones">phones</label>
          <p class="form-control-plaintext m-0 p-0" *ngFor="let phone of record.phones || []; let last = last">
            {{ phone.phoneNumber }}
            <span *ngIf="phone.extension">({{ phone.extension }})</span>
            <fa-icon
              *ngIf="phone.preferentialPhone === true"
              [icon]="'check-circle'"
              [appendTo]="'body'"
              [pTooltip]="'Preferencial'"
            ></fa-icon>
            {{ last ? '' : ',' }}
          </p>
        </div>
        <div class="form-group col col-lg-4">
          <label class="form-control-label" jhiTranslate="app.young.emails">phones</label>
          <p class="form-control-plaintext m-0 p-0" *ngFor="let email of record.emails || []; let last = last">
            {{ email.email }}
            <fa-icon *ngIf="email.preferentialEmail" [icon]="'check-circle'" [appendTo]="'body'" [pTooltip]="'Preferencial'"></fa-icon>
            {{ last ? '' : ',' }}
          </p>
        </div>
        <div class="form-group col col-lg-4">
          <label class="form-control-label" jhiTranslate="app.institution.institutionTypologies">Institution Typology</label>
          <p
            *ngFor="let institutionTypology of record.institutionClient?.institutionTypologies || []; trackBy: trackId"
            class="form-control-plaintext m-0 p-0"
          >
            {{ institutionTypology?.name }}
          </p>
        </div>
      </div>
    </ng-template>
  </li>
  <li [ngbNavItem]="2">
    <a class="flex-sm-fill text-sm-center" ngbNavLink><b>2.</b> Moradas</a>
    <ng-template ngbNavContent>
      <div class="table-responsive">
        <table class="align-items-center table table-flush">
          <thead class="thead-light">
            <tr>
              <th>Morada</th>
              <th>Código Postal</th>
              <th>Freguesia</th>
              <th>Concelho</th>
              <th>Preferencial</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let portugueseAddress of getPortugueseAddress()">
              <td>
                <span>
                  {{ portugueseAddress.postalCode?.arteryType }} {{ portugueseAddress.postalCode?.firstPreposition }}
                  {{ portugueseAddress.postalCode?.arteryTitle }} {{ portugueseAddress.postalCode?.secondPreposition }}
                  {{ portugueseAddress.postalCode?.arteryDesignation }} {{ portugueseAddress.postalCode?.arteryInformation }}
                  {{ portugueseAddress.door && portugueseAddress.door.trim().length > 0 ? ' nº ' : '' }}{{ portugueseAddress.door }}
                  {{ portugueseAddress.floor }} {{ portugueseAddress.side }} {{ portugueseAddress.site }}
                </span>
              </td>
              <td>
                <span *ngIf="portugueseAddress.postalCode?.codeNumber"
                  >{{ portugueseAddress.postalCode?.codeNumber }} -{{ portugueseAddress.postalCode?.codeExtension }}
                </span>
              </td>
              <td>
                {{ portugueseAddress.locality }}
              </td>
              <td>{{ portugueseAddress.postalLocality }}</td>
              <td>
                <fa-icon *ngIf="portugueseAddress.preferential" [fixedWidth]="true" icon="check"></fa-icon>
                <fa-icon *ngIf="!portugueseAddress.preferential" [fixedWidth]="true" icon="times"></fa-icon>
              </td>
            </tr>
            <tr *ngFor="let foreignAddress of getForeignAddress()">
              <td>{{ foreignAddress.postalCode }}</td>
              <td>{{ foreignAddress.locality }}</td>
              <td>{{ foreignAddress.countryId }}</td>
              <td>
                <fa-icon *ngIf="foreignAddress.preferential" [fixedWidth]="true" icon="check"></fa-icon>
                <fa-icon *ngIf="!foreignAddress.preferential" [fixedWidth]="true" icon="times"></fa-icon>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-template>
  </li>
  <li [ngbNavItem]="3">
    <a class="flex-sm-fill text-sm-center" ngbNavLink><b>3.</b> Documentos</a>
    <ng-template ngbNavContent>
      <div class="table-responsive">
        <table class="align-items-center table table-flush">
          <thead class="thead-light">
            <tr>
              <th>Tipo de Documento</th>
              <th>Nº Documento</th>
              <th>Validade</th>
              <th>Emissão</th>
              <th>Estado</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let document of this.record.documents; trackBy: trackDocumentNumber">
              <td>{{ document.documentType?.namePT }}</td>
              <td>{{ document.documentNumber }}</td>
              <td>{{ document.validityDate | formatMediumDate }}</td>
              <td>{{ document.emissionDate | formatMediumDate }}</td>
              <td>
                <span class="float-right badge badge-{{ document.actualState }}"
                  >{{ 'app.DocumentState.' + document.actualState | translate }}
                </span>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-template>
  </li>
</ul>
<div [ngbNavOutlet]="nav"></div>
<hr />
<small>A informação consta do perfil da instituição no Registo Único do IPDJ.</small>
